





































































import Vue from 'vue'
import { Component, Emit, Prop, PropSync, VModel } from 'vue-property-decorator'

@Component
export default class MessagesNavigationButtons extends Vue {
  @VModel() currentMessageIndex!: number

  @Prop() modelsCount!: number

  @Prop() disabled!: boolean

  @Prop({ type: Number, default: 12, required: false }) maxMessagesCount!: number

  @Emit()
  addMessage(): this {
    return this
  }

  @Emit()
  removeMessage(): this {
    return this
  }
}
